import { createSlice } from "@reduxjs/toolkit";
import { newsState } from "./types";

export const initialState: newsState = {
  articles: [],
  loading: false,
  error: false,
  selectedArticles: [],
  newsSources: [],
  newsGenres: [],
  selectedGenre: null,
  genresLoading: false,
  sourcesLoading: false,
  sourceGenres: {},
  sourceGenresLoading: false,
  manualArticles: [],
  manualLoading: false,
  manualError: false,
};

// Helper function to get article ID consistently
const getArticleId = (article: any) => {
  return article.article_id || article._id || article.id;
};

export const newsSlice: any = createSlice({
  name: "news",
  initialState,
  reducers: {
    getNews: (state) => {
      state.loading = true;
    },
    getNewsSuccess: (state, action) => {
      state.articles = action.payload;
      state.loading = false;
    },
    getNewsFailed: (state) => {
      state.loading = false;
      state.error = true;
    },
    addNews: (state, action) => {
      const newsAdd = action.payload;
      const newsId = getArticleId(newsAdd);

      const alreadyAdded = state.selectedArticles.some(
        (news: any) => getArticleId(news) === newsId
      );

      if (!alreadyAdded) {
        state.selectedArticles = [...state.selectedArticles, action.payload];
      }
      if (alreadyAdded) {
        state.selectedArticles = state.selectedArticles.filter(
          (article: any) => getArticleId(article) !== newsId
        );
      }
    },
    dragNews: (state, action) => {
      state.selectedArticles = action.payload;
    },
    removeNews: (state, action) => {
      state.selectedArticles = state.selectedArticles.filter(
        (item: any) => getArticleId(item) !== action.payload
      );
    },
    clearCart: (state: any) => {
      state.selectedArticles = [];
    },
    getSources: (state) => {
      state.sourcesLoading = true;
    },
    getSourcesSuccess: (state, action) => {
      state.newsSources = action.payload;
      state.sourcesLoading = false;
    },

    setSelectedGenre(state, action) {
      state.selectedGenre = action.payload;
    },
    getSourcesFailed: (state) => {
      state.sourcesLoading = false;
    },
    getGenres: (state) => {
      state.genresLoading = true;
    },
    getGenresSuccess: (state, action) => {
      state.newsGenres = action.payload;
    },
    getGenresFailed: (state) => {
      state.genresLoading = false;
    },
    getSourceGenres: (state) => {
      state.sourceGenresLoading = true;
    },
    getSourceGenresSuccess: (state, action) => {
      state.sourceGenres = action.payload;
      state.sourceGenresLoading = false;
    },
    getSourceGenresFailed: (state) => {
      state.sourceGenresLoading = false;
    },
    getManualNews: (state) => {
      state.manualLoading = true;
      state.manualError = false;
    },
    getManualNewsSuccess: (state, action) => {
      state.manualArticles = action.payload;
      state.manualLoading = false;
    },
    getManualNewsFailed: (state) => {
      state.manualLoading = false;
      state.manualError = true;
    },
  },
});

export const {
  getNews,
  getNewsSuccess,
  getNewsFailed,
  addNews,
  removeNews,
  dragNews,
  clearCart,
  getSources,
  getSourcesSuccess,
  getSourcesFailed,
  getGenres,
  getGenresSuccess,
  selectedGenre,
  getSourceGenres,
  getSourceGenresSuccess,
  getSourceGenresFailed,
  getGenresFailed,
  getManualNews,
  getManualNewsSuccess,
  getManualNewsFailed,
} = newsSlice.actions;
export default newsSlice.reducer;
